import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import appointdocLogo from '../assets/appointdoc-logo.png';
import { useTranslation } from '../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t bg-white">
      <div className="container mx-auto max-w-6xl px-4 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid gap-12 py-16 md:grid-cols-12">
          {/* Brand Column */}
          <div className="md:col-span-4">
            <Link
              to="/"
              className="inline-block mb-1 hover:opacity-90 transition-opacity"
            >
              <img
                src={appointdocLogo}
                alt="AppointDoc"
                width={180}
                height={45}
                className="h-[45px] w-auto"
              />
            </Link>
            <p className="text-gray-600 mb-8 max-w-md">
              {t('heroDescription')}
            </p>
            <div className="flex gap-6">
              <Link
                to="#"
                className="text-gray-400 hover:text-teal-500 transition-colors"
                aria-label="Facebook"
              >
                <FaFacebook className="h-5 w-5" />
              </Link>
              <Link
                to="#"
                className="text-gray-400 hover:text-teal-500 transition-colors"
                aria-label="Twitter"
              >
                <FaTwitter className="h-5 w-5" />
              </Link>
              <Link
                to="#"
                className="text-gray-400 hover:text-teal-500 transition-colors"
                aria-label="Instagram"
              >
                <FaInstagram className="h-5 w-5" />
              </Link>
              <Link
                to="#"
                className="text-gray-400 hover:text-teal-500 transition-colors"
                aria-label="LinkedIn"
              >
                <FaLinkedin className="h-5 w-5" />
              </Link>
            </div>
          </div>

          {/* Navigation Columns */}
          <nav className="grid gap-8 sm:grid-cols-3 md:col-span-8">
            <div>
              <h3 className="font-semibold text-base mb-3">{t('product')}</h3>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="#features"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('features')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#pricing"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('pricing')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('hipaaCompliant')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('enterprise')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('customerStories')}
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-base mb-3">{t('platform')}</h3>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('primaryCare')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('dentalClinics')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('physicalTherapy')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('mentalHealth')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('apiDocumentation')}
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-base mb-3">{t('company')}</h3>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('aboutUs')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('careers')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('press')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('contact')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-gray-600 hover:text-teal-500 transition-colors text-sm"
                  >
                    {t('partners')}
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col gap-6 border-t py-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} AppointDoc. {t('allRightsReserved')}
          </p>
          <nav className="flex flex-wrap gap-6">
            <Link
              to="#"
              className="text-sm text-gray-600 hover:text-teal-500 transition-colors"
            >
              {t('privacyPolicy')}
            </Link>
            <Link
              to="#"
              className="text-sm text-gray-600 hover:text-teal-500 transition-colors"
            >
              {t('termsOfService')}
            </Link>
            <Link
              to="#"
              className="text-sm text-gray-600 hover:text-teal-500 transition-colors"
            >
              {t('cookieSettings')}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
